import React from 'react';
import { setCurrentView } from 'core/utils';
import { ReturnedItemsListDetailViewStore } from 'modules/order/stores';
import { ReturnedItemsListDetailTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, props) => new ReturnedItemsListDetailViewStore(rootStore, props),
	'returnedItemsListDetailViewStore'
)
class ReturnedItemsListDetail extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ReturnedItemsListDetailTemplate store={this.props.returnedItemsListDetailViewStore} />;
	}
}

export default ReturnedItemsListDetail;



// WEBPACK FOOTER //
// ./src/modules/order/pages/ReturnedItemsListDetail.jsx